import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { startCase } from "lodash";

class ErrorModal extends Component {
  render() {
    const { show, closeModal, errors } = this.props;

    return (
      <Modal show={show} onHide={() => closeModal()}>
        <Modal.Header closeButton>
          <Modal.Title>Errors</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-danger">Please fix the following errors before continuing.</p>
          {
            Object.keys(errors).map((key) => {
              const error = errors[key];
              return (
                <ul key={key}>
                  {
                    error.map((msg) => {
                      return (
                        <li key={key}>
                          <strong>{startCase(key)} </strong>
                          <span>{msg} </span>
                        </li>
                      );
                    })
                  }
                </ul>
              )
            })
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => closeModal()}>
            Dismiss
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.errorModal.show,
    errors: state.ui.errorModal.errors
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "error" }})
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModal);
